import { UserGetResponseType } from "@sellar-io/api-v2/types";
import { useState } from "react";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";
import femaleOneImage from "../../images/profileImages/f1.jpg";
import femaleTwoImage from "../../images/profileImages/f2.jpg";
import femaleThreeImage from "../../images/profileImages/f3.jpg";
import maleOneImage from "../../images/profileImages/m1.jpg";
import maleTwoImage from "../../images/profileImages/m2.jpg";
import { Alert } from "../alert/Alert";
import { Button, Icon } from "@sellar-io/components";
import {
  ProfilePictureCollection,
  ProfilePictureCollectionImage,
} from "../profilePictureCollection/profilePictureCollection";
import { Prompt, PromptHeader, PromptContent } from "../prompt/Prompt";
import { ProfileImageUploadDialog } from "./ProfileImageUploadDialog";

const images = [
  femaleOneImage,
  maleOneImage,
  femaleTwoImage,
  maleTwoImage,
  femaleThreeImage,
];

export function ProfileImagePrompt({ user }: { user: UserGetResponseType }) {
  const { business } = useSellarCurrentBusiness();
  const [profileImageUploadModalActive, setProfileImageUploadModalActive] =
    useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  return (
    <>
      {showSuccess ? (
        <div className="p-4">
          <Alert
            className={"w-full"}
            message={"Profile photo added!"}
            type={"success"}
          />
        </div>
      ) : (
        <>
          {user && !user.profileImageUrl && (
            <div className="p-4">
              <Prompt
                className={"flex w-full flex-col gap-2"}
                type={"information"}
              >
                <PromptContent>
                  <ProfilePictureCollection>
                    {images.map((image, index) => (
                      <ProfilePictureCollectionImage
                        key={index}
                        imageUrl={image}
                      />
                    ))}
                  </ProfilePictureCollection>
                </PromptContent>
                <PromptHeader type={"information"}>
                  Put a face to a name
                </PromptHeader>
                <PromptContent className={"flex flex-col gap-4"}>
                  <span className={"text-black"}>
                    {business?.Supplier
                      ? "Let your customers see who they’re dealing with by adding a profile photo."
                      : "Let suppliers see who they’re dealing with by adding a profile photo."}
                  </span>
                  <Button
                    onClick={() => setProfileImageUploadModalActive(true)}
                    className={"bg-blue-800 text-white hover:bg-blue-700"}
                  >
                    <Icon icon={"UPLOAD"} />
                    Upload photo
                  </Button>
                </PromptContent>
              </Prompt>
            </div>
          )}
        </>
      )}
      <ProfileImageUploadDialog
        active={profileImageUploadModalActive}
        onDismiss={() => setProfileImageUploadModalActive(false)}
        onSuccess={() => setShowSuccess(true)}
        userId={user.id}
      />
    </>
  );
}
